<template>
  <component :is="component_name" :data="data" :order="order" :readMore="true" />
</template>

<script>
  import sections from '@/components/sections/index'

  export default {
    name: 'sections',

    data() {
      return {
        component_name: ''
      }
    },

    props: {
      data: {
        type: Object,
        default: {},
      },
      pos: {
        type: String,
        default: null
      },
      order: {
        type: Number,
        default: 0
      }
    },

    components: sections,

    mounted() {
      if(
        (this.pos === "top" && this.data.acf_fc_layout === 'slideshow') ||
        (this.pos === "bottom" && this.data.acf_fc_layout !== 'slideshow')
      ) {
        return null;
      }

      switch (this.data.acf_fc_layout) {
        case 'content':
          this.component_name = 'Content';
          break;
        case 'bg_content':
          this.component_name = 'BgContent';
          break;
        case 'slideshow':
          this.component_name = 'SlideshowBlock';
          break;
        case 'two_content':
          this.component_name = 'DoubleInfoBlock';
          break;
        case 'accordion':
          this.component_name = 'Accordion';
          break;
        case 'google_map':
          this.component_name = 'Map';
          break;
      }
    },
  }
</script>
